



































































import {Vue, Component} from 'vue-property-decorator'
import {Button} from 'mand-mobile'
import analyze from 'guardian-liveness-detection-lib/src/libs/analyze'
import 'vue-loading-overlay/dist/vue-loading.css'
import * as Sentry from '@sentry/browser'

// flow
import store from '@/store'
import {takePhotoHandler} from '@/lib/photograph-flow/flow/takePhoto'
import {loadHandler} from '@/lib/photograph-flow/flow/load'
import {checkHandler, CheckResultType} from '@/lib/photograph-flow/flow/check'
import {resolveHandler} from '@/lib/photograph-flow/flow/resolve'
import {analyzeImages} from '@/lib/photograph-flow/lib/resolveImage'
import {uploadHandler} from '@/lib/photograph-flow/flow/upload'
import DialogPrompt from '@/views/common/DialogPrompt.vue'

// event tracking
import { getReport, sendReport } from '@/lib/imageReport'
import { imageInvalidTokenCheckAndHandler } from '@/lib/invalidTokenCheckAndHandler'

// tslint:disable-next-line
const Loading = require('vue-loading-overlay')
// Maximum acceptable image
const MAX_SIZE = 5 * 1024 * 1024 // byte

interface IFileObj {
  file: File
  image?: HTMLImageElement
}

interface IResolveResult {
  file?: Blob[],
  imageFileFullName?: string,
  imageOrigFormat?: string,
  imageOrigSize?: number,
  imageOrigWidth?: number,
  imageOrigHeight?: number,
  isResolved?: boolean,
  resolveTime?: number,
  imageResolvedFormat?: string,
  imageResolvedSize?: number,
  imageResolvedWidth?: number
  imageResolvedHeight?: number
  errorMsg?: string,
}

interface IUploadResult {
  code?: string,
  message?: string,
  uploadTime?: number,
  transactionId?: string,
  score?: number,
  errorMsg?: string,
  tryCount?: number,
  returnUrl?: string,
}

@Component({components: {[Button.name]: Button, Loading, DialogPrompt}})
export default class Home extends Vue {
  bizToken: any = null
  failedReturnUrl: any = null
  failedCode: string = ''
  failedMessage: any = null
  isAllowUpload: boolean = false
  preparing: boolean = false
  loading: boolean = false
  resolveFile: Blob[] = []
  compressedFile: any = null
  resolveResult: null | IResolveResult = null
  uploadResult: null | IUploadResult = null
  imageBasicInfo: any = null
  imageMetaData: any = null

  // dialog
  formatNotSupportHint: boolean = false
  resolveFailedHint: boolean = false
  unresolvedVideoSizeTooBigHint: boolean = false

  async startHandler() {
    try {

      // step1 - take photo
      // console.log('take photo......')
      const file = await takePhotoHandler()
      // console.log('file', file)


      // step2 - load
      // console.log('load......')
      this.preparing = true
      const loadImage = await loadHandler(file)
      this.preparing = false
      // console.log('loadImage', loadImage)


      // step3 - check
      // console.log('per check......')
      this.loading = true
      const checkFile = await checkHandler(loadImage)
      this.imageMetaData = analyze(loadImage.file, loadImage.image as any)
      switch (checkFile.type) {
        case CheckResultType.FILE_SUFFIX_NOT_MATCH:
          this.formatNotSupportHint = true
          this.failedCode = 'UNACCEPTED_SUFFIX'
          this.failedMessage = this.$t(`home.formatNotSupport`)
          this.sendReportPreCheck(false, 'UNACCEPTED_SUFFIX', checkFile.fileObj, false)
          return
      }


      // step4 - resolve  checkFile.type === 'NEED_RESOLVE'
      // console.log('compressing......')
      // console.log('file origin size', `${file.size / 1024}k`)
      try {
        const resolveStartTime = new Date().getTime()
        this.resolveFile = await resolveHandler(
          checkFile.fileObj.image as HTMLImageElement, checkFile.fileObj.file.size,
        )
        // console.log('resolve file', this.resolveFile)
        this.compressedFile = analyzeImages(this.resolveFile)
        // console.log('compressed image info', this.compressedFile)
        this.resolveResult = {
          imageFileFullName: checkFile.fileObj.file.name,
          imageOrigFormat: this.imageMetaData.fileSuffix,
          imageOrigSize: checkFile.fileObj.file.size,
          imageOrigWidth: this.imageMetaData ? this.imageMetaData.width : 0,
          imageOrigHeight: this.imageMetaData ? this.imageMetaData.height : 0,
          isResolved: this.resolveFile instanceof Array ? true : false,
          resolveTime: new Date().getTime() - resolveStartTime,
          imageResolvedFormat: this.compressedFile.dataType === 'image/webp' ? 'webp' : 'jpeg',
          imageResolvedSize: this.compressedFile.size * 1024,
          imageResolvedWidth: this.compressedFile.resolvedWidth,
          imageResolvedHeight: this.compressedFile.resolvedHeight,
        }
      } catch (error) {
        // console.log('resolve failed', error)
        this.resolveFailedHint = true
        this.failedCode = 'NONSUPPORT_DEVICE'
        this.failedMessage = this.$t(`home.resolveFailed`)
        Sentry.captureException(error)
        this.sendReportResolve(false, (error as any).message, this.resolveResult || {}, false)
        return
      }


      // step5 - upload
      await this.overtakeMaximumSizeReject(this.compressedFile.size * 1024)
      await this.uploadStep({ images: this.resolveFile })
    } catch (error) {
      console.error('input_load_check failed', error)
      this.unresolvedVideoSizeTooBigHint = true
      this.failedCode = 'NONSUPPORT_NETWORK'
      this.failedMessage = this.$t(`home.unresolvedVideoSizeTooBig`)
      Sentry.captureException(error)
      this.sendReportResolve(false, (error as any).message, this.resolveResult || {}, false)
      return
    } finally {
      this.loading = false
    }
  }

  async uploadStep(payload: {file?: File; images?: Blob[]}) {
    try {
      // console.log('uploading......')
      const uploadStartTime = new Date().getTime()
      const uploadReturnData = await uploadHandler(payload, this.bizToken)
      const uploadResult = {
        code: uploadReturnData.code,
        message: uploadReturnData.message,
        transactionId: uploadReturnData.transactionId,
        score: uploadReturnData.data ? uploadReturnData.data.score : 0,
        uploadTime: new Date().getTime() - uploadStartTime,
        tryCount: uploadReturnData.data ? uploadReturnData.data.tryCount : 0,
        returnUrl: uploadReturnData.data ? uploadReturnData.data.returnUrl : '',
      }
      this.uploadResult = uploadResult


      this.imageBasicInfo = {
        imageFileFullName: payload.file ? payload.file.name : '',
        imageOrigFormat: this.imageMetaData ? this.imageMetaData.fileSuffix : '',
        imageOrigSize: payload.file ? payload.file.size : 0,
        imageOrigWidth: this.imageMetaData ? this.imageMetaData.width : 0,
        imageOrigHeight: this.imageMetaData ? this.imageMetaData.height : 0,
        isResolved: false,
      }

      // if is invalid token, direct to result page
      if (imageInvalidTokenCheckAndHandler(uploadResult.code as string)) {
        return
      }

      if (uploadReturnData.code === 'SUCCESS') {
        this.sendReportUpload(true, uploadResult.message, this.resolveResult || this.imageBasicInfo, uploadResult, true)
      } else {
        this.sendReportUpload(false, uploadResult.message, this.resolveResult || this.imageBasicInfo, uploadResult, true)
      }

      // console.log('upload success')
      this.pageJumpHandler(uploadReturnData)
    } catch (error) {
      // console.error('upload failed', error)
      this.resolveFailedHint = true
      this.failedCode = 'NONSUPPORT_DEVICE'
      this.failedMessage = this.$t(`home.resolveFailed`)
      Sentry.captureException(error)
      this.sendReportUpload(false, (error as any).messages, this.resolveResult || this.imageBasicInfo, this.uploadResult || {}, false)
      return
    }
  }

  pageJumpHandler(data: any) {
    this.$router.push({
      name: 'ImageResult',
      query: {
        result: data.code,
        message: data.message,
        score: data.data ? `${data.data.score}` : '',
        returnUrl: data.data ? data.data.returnUrl : '',
      },
    })
  }

  overtakeMaximumSizeReject(size: number, fileObjInfo?: IFileObj) {
    return new Promise<void>((resolve, reject) => {
      if (size > MAX_SIZE) {
        console.warn('file size more than 5M')
        this.loading = false
        this.resolveFailedHint = true
        this.failedCode = 'NONSUPPORT_DEVICE'
        this.failedMessage = this.$t(`home.resolveFailed`)
        this.sendReportResolve(false, 'NONSUPPORT_DEVICE', this.resolveResult || {}, false)
        return
      }
      resolve()
    })
  }

  failedReturnUrlHandler() {
    location.href = `${this.failedReturnUrl}?failedCode=${this.failedCode}&failedMessage=${this.failedMessage}&version=image`
  }

  hideDialogHandler() {
    if (this.failedReturnUrl) {
      this.failedReturnUrlHandler()
    } else {
      this.formatNotSupportHint = false
      this.resolveFailedHint = false
      this.unresolvedVideoSizeTooBigHint = false
    }
  }

  mounted() {
    this.bizToken = this.$route.query.biz_token
    this.failedReturnUrl = this.$route.query.failedReturnUrl
    store.bizToken = this.$route.query.biz_token as string
    store.failedReturnUrl = this.$route.query.failedReturnUrl as string
    if (this.bizToken) {
      this.isAllowUpload = true
      return
    }
  }

  sendReportPreCheck(result: boolean, message: string, fileObj?: IFileObj, isJump?: boolean) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'PRE_CHECK'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.imageFileFullName = fileObj ? fileObj.file.name : ''
    reportDetail.imageOrigFormat = fileObj ? fileObj.file.type : ''
    reportDetail.imageOrigSize = fileObj ? fileObj.file.size : 0
    sendReport(report, message, isJump)
  }

  getReportResolve(result: boolean, message: string, resolveResult: IResolveResult, isJump?: boolean) {
    const report = getReport()
    const reportDetail = report.info.detail
    reportDetail.state = 'RESOLVE'
    reportDetail.result = result
    reportDetail.message = message
    reportDetail.imageFileFullName = resolveResult.imageFileFullName
    reportDetail.imageOrigFormat = resolveResult.imageOrigFormat
    reportDetail.imageOrigSize = resolveResult.imageOrigSize
    reportDetail.imageOrigWidth = resolveResult.imageOrigWidth
    reportDetail.imageOrigHeight = resolveResult.imageOrigHeight

    reportDetail.isResolved = resolveResult.isResolved
    reportDetail.resolveTime = resolveResult.resolveTime
    reportDetail.imageResolvedFormat = resolveResult.imageResolvedFormat
    reportDetail.imageResolvedSize = resolveResult.imageResolvedSize
    reportDetail.imageResolvedWidth = resolveResult.imageResolvedWidth
    reportDetail.imageResolvedHeight = resolveResult.imageResolvedHeight

    return report
  }

  sendReportResolve(result: boolean, message: string, resolveResult: IResolveResult, isJump?: boolean) {
    sendReport(this.getReportResolve(result, message, resolveResult, isJump))
  }

  sendReportUpload(result: boolean, message: string, resolveResult: IResolveResult, uploadResult: IUploadResult, isJump?: boolean) {
    const report = this.getReportResolve(result, message, resolveResult)
    const reportDetail = report.info.detail
    reportDetail.state = 'UPLOAD'
    reportDetail.uploadTime = uploadResult.uploadTime
    reportDetail.transactionId = uploadResult.transactionId
    reportDetail.score = uploadResult.score
    reportDetail.tryCount = uploadResult.tryCount,
    reportDetail.returnUrl = uploadResult.returnUrl,
    sendReport(report, message, isJump)
  }
}
